import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    customProperties: true,
    theme: {
        themes: {
            light: {
                primary: '#000000',
                secondary: '#ffffff',
                decline: '#ea203c',
                accept: '#43ce00',
                finishJob: '#ffa500',
                addStuff: '#ffd580',
                perfectared: '#cf2e2e'
            }
        }
    }
});
